import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d28222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "fw-700"
}
const _hoisted_3 = ["data-dp-tooltip", "data-dp-position"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas" }, "help", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "form-help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('mb-' + this.mb)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (this.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(this.title), 1))
        : _createCommentVNode("", true),
      (this.help)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            "data-dp-tooltip": this.help,
            "data-dp-position": this.helpPosition,
            class: "d-flex cu-p ms-2"
          }, _hoisted_5, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (this.subtitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(this.subtitle), 1))
      : _createCommentVNode("", true)
  ], 2))
}